/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommerceSpecTenant } from './commerceSpecTenant';


export interface ActivateVLRSpecTenant { 
    components: Array<CommerceSpecTenant>;
}

